var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: "512px",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M368.003,117.456c-44.426,0-68.012,22.217-102.915,21.764   c-34.912,0.453-58.49-21.764-102.922-21.764c-35.364,0-80.257,21.764-100.657,53.511c-37.629,58.048-34.005,121.088-18.135,186.378   C60.603,426.744,121.358,512,169.421,512c39.441,0,57.131-21.325,95.667-21.325c38.526,0,55.756,21.325,94.76,21.325   c44.425,0,97.472-73.023,120.152-137.876c-43.534-17.232-73.01-60.306-73.01-106.113c0-45.346,23.133-80.264,58.498-100.215   C443.729,138.314,402.008,117.456,368.003,117.456L368.003,117.456z M356.209,0c-63.918,6.804-111.521,60.313-107.444,121.081   C312.691,114.731,359.848,60.767,356.209,0L356.209,0z",
    fill: "#C6C7C9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.132fadadeaf233298aab508bb298703f.svg";
export { ForwardRef as ReactComponent };